import logo from './logo.svg';
import './App.css';
import  'font-awesome/css/font-awesome.min.css';
import CountTime from './components/coutTime/countTime';
import Portfolio from './components/portfolioportfolio/portfolio';



function App() {
  return (
    <div className="App">
    <CountTime/>
    <Portfolio/>

      
    </div>
  );
}

export default App;



